import React, {useEffect, useState} from 'react'
import axios from 'axios'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {LifestyleBanner} from '../../components/LifestyleBoulevard/LifestyleBanner'

import {EditorState} from 'draft-js'
import {stateFromHTML} from 'draft-js-import-html'
import {Editor} from 'react-draft-wysiwyg'
import {convertToHTML} from 'draft-convert'

import '../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import {Amenidades} from '../../components/LifestyleBoulevard/Amenidades'
import {LifeServicios} from '../../components/LifestyleBoulevard/LifeServicios'

function LifestyleBoulevard() {
  const url = 'https://puntosurgdl.com/backend/'

  const [amenidades, setAmenidades] = useState('')

  const [spinnerIsActive, setSpinnerIsActive] = useState(false)

  const [textSectionOne, setTextSectionOne] = useState('')
  const [editorOneRawHtml, setEditorOneRawHtml] = useState('')

  const [editorOneState, setEditorOneState] = useState(() =>
    EditorState.createWithContent(stateFromHTML(editorOneRawHtml))
  )

  const [convertedContentOne, setConvertedContentOne] = useState(null)

  useEffect(() => {
    let html = convertToHTML(editorOneState.getCurrentContent())
    setConvertedContentOne(html)
  }, [editorOneState])

  const [textSectionTwo, setTextSectionTwo] = useState('')
  const [editorTwoRawHtml, setEditorTwoRawHtml] = useState('')

  const [editorTwoState, setEditorTwoState] = useState(() =>
    EditorState.createWithContent(stateFromHTML(editorTwoRawHtml))
  )

  const [convertedContentTwo, setConvertedContentTwo] = useState(null)

  const [lifeServicios, setLifeServicios] = useState('')

  useEffect(() => {
    let html = convertToHTML(editorTwoState.getCurrentContent())
    setConvertedContentTwo(html)
  }, [editorTwoState])

  useEffect(() => {
    getTextSectionOne()
    getTextSectionTwo()
    // setEditorOneRawHtml()
    getAmenidades()
    getLifeServicios()
  }, [editorOneRawHtml, editorTwoRawHtml])

  const saveTextSectionOne = () => {
    convertToHTML(editorOneState.getCurrentContent())

    const dataForm = new FormData()

    dataForm.append('name', 'lifestyle-text-section-1')
    dataForm.append('title', document.getElementById('lifestyle-text-section-1-title').value)
    dataForm.append('description', convertedContentOne)
    // const dataForm = {
    //   name: 'lifestyle-text-section-1',
    //   title: document.getElementById('lifestyle-text-section-1-title').value,
    //   description: convertedContentOne,
    // }
    if (document.getElementById('lifestyle-text-section-1-img').files.length !== 0) {
      for (
        let i = 0;
        i < document.getElementById('lifestyle-text-section-1-img').files.length;
        i++
      ) {
        dataForm.append('file[]', document.getElementById('lifestyle-text-section-1-img').files[i])
      }
    }

    axios
      .post(url + 'saveLifestyleTextSectionOne.php', dataForm, {
        // receive two parameter endpoint url ,form data
      })
      .then(
        (res) => {
          // then print response status
          document.getElementsByName('lifestyle-text-section-1-img')[0].value = null
          console.log(res)
        },
        (error) => {
          alert(error)
        }
      )
  }

  const saveTextSectionTwo = () => {
    convertToHTML(editorOneState.getCurrentContent())

    const dataForm = new FormData()

    dataForm.append('name', 'lifestyle-text-section-2')
    dataForm.append('title', document.getElementById('lifestyle-text-section-2-title').value)
    dataForm.append('description', convertedContentTwo)
    // const dataForm = {
    //   name: 'lifestyle-text-section-2',
    //   title: document.getElementById('lifestyle-text-section-2-title').value,
    //   description: convertedContentOne,
    // }
    // if (document.getElementById('lifestyle-text-section-2-img').files.length !== 0) {
    //   for (
    //     let i = 0;
    //     i < document.getElementById('lifestyle-text-section-2-img').files.length;
    //     i++
    //   ) {
    //     dataForm.append('file[]', document.getElementById('lifestyle-text-section-2-img').files[i])
    //   }
    // }

    axios
      .post(url + 'saveLifestyleTextSectionOne.php', dataForm, {
        // receive two parameter endpoint url ,form data
      })
      .then(
        (res) => {
          // then print response status
          //document.getElementsByName('lifestyle-text-section-2-img')[0].value = null
          console.log(res)
        },
        (error) => {
          alert(error)
        }
      )
  }

  const getTextSectionOne = () => {
    axios
      .get(url + 'getLifestyleTextSectionOne.php')
      .then((response) => {
        console.log(response.data.data[0])
        setEditorOneRawHtml(response.data.data[0].description)
        setEditorOneState(() => EditorState.createWithContent(stateFromHTML(editorOneRawHtml)))
        setTextSectionOne(response.data.data[0])
      })
      .catch((error) => console.error('Error: ' + error))
  }

  const getTextSectionTwo = () => {
    axios
      .get(url + 'getLifestyleTextSectionTwo.php')
      .then((response) => {
        console.log(response.data.data[0])
        setEditorTwoRawHtml(response.data.data[0].description)
        setEditorTwoState(() => EditorState.createWithContent(stateFromHTML(editorTwoRawHtml)))
        setTextSectionTwo(response.data.data[0])
      })
      .catch((error) => console.error('Error: ' + error))
  }

  const getAmenidades = () => {
    axios
      .get(url + 'getAmenidades.php')
      .then((response) => {
        console.log(response.data.data[0])
        setAmenidades(response.data.data)
      })
      .catch((error) => console.error('Error: ' + error))
  }

  const getLifeServicios = () => {
    axios
      .get(url + 'getLifeServicios.php')
      .then((response) => {
        console.log(response.data.data[0])
        setLifeServicios(response.data.data)
      })
      .catch((error) => console.error('Error: ' + error))
  }

  return (
    <div className='row g-5'>
      <LifestyleBanner />

      <div className='col-lg-12'>
        <div className='card card-custom card-stretch shadow mb-5 video-banner'>
          <div className='card-header'>
            <h3 className='card-title'>Sección texto 1</h3>
            <h5 className='card-subtitle'>
              La imagen debe tener un formato vertical, con una medida mínima de 550px por 600px y
              no pesar más de 1MB
            </h5>
          </div>
          <div className='card-body'>
            <div className='row'>
              <div className='form-group col-md-12'>
                <label>Titulo:</label>
                <input
                  type='text'
                  className='form-control'
                  id='lifestyle-text-section-1-title'
                  defaultValue={textSectionOne.title}
                />
              </div>
            </div>
            <div className='form-group col-md-12'>
              <label>Contenido:</label>
              <Editor
                editorState={editorOneState}
                toolbarClassName='toolbarClassName'
                wrapperClassName='wrapperClassName'
                onEditorStateChange={setEditorOneState}
              />
            </div>
            <div className='row'>
              <div className='form-group col-md-12'>
                <label>Imagen:</label>
                <input
                  type='file'
                  className='form-control'
                  id='lifestyle-text-section-1-img'
                  name='lifestyle-text-section-1-img'
                  accept='image/*'
                />
              </div>
            </div>
          </div>
          <div className='card-footer'>
            <div className='form-group float-end'>
              <button
                type='submit'
                className='btn btn-primary mt-6'
                onClick={() => saveTextSectionOne()}
              >
                Guardar
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className='col-lg-12'>
        <div className='card card-custom card-stretch shadow mb-5 video-banner'>
          <div className='card-header'>
            <h3 className='card-title'>Amenidades</h3>
            <h5 className='card-subtitle'>
              Las imágenes deben tener una medida de 1920px por 1000px y no pesar más de 1MB
            </h5>
          </div>
          <div className='card-body'>
            <div className='row'>
              <Amenidades amenidades={amenidades} />
            </div>
          </div>
          {/* <div className='card-footer'>
            <div className='form-group float-end'>
              <button type='submit' className='btn btn-primary mt-6'>
                Guardar
              </button>
            </div>
          </div> */}
        </div>
      </div>

      <div className='col-lg-12'>
        <div className='card card-custom card-stretch shadow mb-5 video-banner'>
          <div className='card-header'>
            <h3 className='card-title'>Sección texto 2</h3>
          </div>
          <div className='card-body'>
            <div className='row'>
              <div className='form-group col-md-12'>
                <label>Titulo:</label>
                <input
                  type='text'
                  className='form-control'
                  id='lifestyle-text-section-2-title'
                  defaultValue={textSectionTwo.title}
                />
              </div>
            </div>
            <div className='form-group col-md-12'>
              <label>Contenido:</label>
              <Editor
                editorState={editorTwoState}
                toolbarClassName='toolbarClassName'
                wrapperClassName='wrapperClassName'
                onEditorStateChange={setEditorTwoState}
              />
            </div>
          </div>
          <div className='card-footer'>
            <div className='form-group float-end'>
              <button
                type='submit'
                className='btn btn-primary mt-6'
                onClick={() => saveTextSectionTwo()}
              >
                Guardar
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className='col-lg-12'>
        <div className='card card-custom card-stretch shadow mb-5 video-banner'>
          <div className='card-header'>
            <h3 className='card-title'>Servicios</h3>
            <h5 className='card-subtitle'>
              La imagen debe tener un formato vertical, con una medida mínima de 400px por 500px y
              no pesar más de 1MB
            </h5>
          </div>
          <div className='card-body'>
            <div className='row'>
              <LifeServicios servicios={lifeServicios} />
            </div>
          </div>
          {/* <div className='card-footer'>
            <div className='form-group float-end'>
              <button type='submit' className='btn btn-primary mt-6'>
                Guardar
              </button>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  )
}

export {LifestyleBoulevard}
